export default function generateID() {
    if (self.crypto && "randomUUID" in self.crypto) {
        return self.crypto.randomUUID().toString();
    }
    return Array.from({ length: 32 }, function () { return Math.random().toString(16).slice(2); }).join("");
}
